import { createAction, props, Action } from '@ngrx/store';
import { ICustomerDetailsPage } from '@nx-ng/types';
import {
  ApiError,
  CreateCustomerRequest,
  Customer,
  GetApplicantSwiftcardsResponse,
  GetCustomerApplicantsResponse,
  UpdateCustomerRequest,
} from '../client/src';

// Note sure we need this action any more
export const init = createAction('[DataAccessCustomerDetails] Init');

export const LOAD_CUSTOMER_DETAILS_TYPE = '[DataAccessCustomerDetails] Load';
export const loadDataAccessCustomerDetails = createAction(
  LOAD_CUSTOMER_DETAILS_TYPE
);

export const loadDataAccessCustomerDetailsSuccess = createAction(
  `${LOAD_CUSTOMER_DETAILS_TYPE} Success`,
  props<{ loadedCustomer: Customer }>()
);

export const loadDataAccessCustomerDetailsFailure = createAction(
  `${LOAD_CUSTOMER_DETAILS_TYPE} Failure`,
  props<{ error: string | ApiError; retryAction?: Action }>()
);

export const loadDataAccessCustomerDetailsNotFound = createAction(
  '[DataAccessCustomerDetails] Load Not Found'
);

export const LOAD_BILLING_CUSTOMER_APPLICANTS_TYPE =
  '[DataAccessCustomerDetails] Load Billing Customer Applicants';
export const customerAPI_loadBillingCustomerApplicants = createAction(
  LOAD_BILLING_CUSTOMER_APPLICANTS_TYPE,
  props<{ billingCustomerEmail: string }>()
);

export const customerAPI_loadBillingCustomerApplicantsSuccess = createAction(
  `${LOAD_BILLING_CUSTOMER_APPLICANTS_TYPE} Success`,
  props<{ applicants: GetCustomerApplicantsResponse }>()
);

export const customerAPI_loadBillingCustomerApplicantsFailure = createAction(
  `${LOAD_BILLING_CUSTOMER_APPLICANTS_TYPE} Failure`,
  props<{ error: string | ApiError; retryAction?: Action }>()
);

export const saveCustomerFromAccountPage = createAction(
  '[DataAccessCustomerDetails] Save Customer',
  props<{ customerFormData: ICustomerDetailsPage }>()
);

export const CREATE_CUSTOMER_TYPE =
  '[DataAccessCustomerDetails] Create Customer API';
export const customerAPI_CreateCustomer = createAction(
  CREATE_CUSTOMER_TYPE,
  props<{ customerToCreate: CreateCustomerRequest }>()
);

export const customerAPI_CreateCustomerSuccess = createAction(
  `${CREATE_CUSTOMER_TYPE} Success`,
  props<{ createdCustomer: Customer }>()
);

export const customerAPI_CreateCustomerFailure = createAction(
  `${CREATE_CUSTOMER_TYPE} Failure`,
  props<{ error: string | ApiError; retryAction?: Action }>()
);

export const UPDATE_CUSTOMER_TYPE =
  '[DataAccessCustomerDetails] Update Customer API';
export const customerAPI_UpdateCustomer = createAction(
  UPDATE_CUSTOMER_TYPE,
  props<{ customerId: string; customerToUpdate: UpdateCustomerRequest }>()
);

export const customerAPI_UpdateCustomerSuccess = createAction(
  `${UPDATE_CUSTOMER_TYPE} Success`,
  props<{ updatedCustomer: Customer }>()
);

export const customerAPI_UpdateCustomerFailure = createAction(
  `${UPDATE_CUSTOMER_TYPE} Failure`,
  props<{ error: string | ApiError; retryAction?: Action }>()
);

export const GET_APPLICANT_SWIFTCARDS_TYPE =
  '[DataAccessCustomerDetails] Get Applicant Swiftcards API';
export const customerAPI_GetApplicantSwiftCards = createAction(
  GET_APPLICANT_SWIFTCARDS_TYPE,
  props<{
    applicantCustomerID: string;
    ticketID: number;
    save?: boolean;
  }>()
);

export const customerAPI_GetApplicantSwiftCardsSuccess = createAction(
  `${GET_APPLICANT_SWIFTCARDS_TYPE} Success`,
  props<{
    applicantCustomerID: string;
    ticketID: number;
    swiftCards: GetApplicantSwiftcardsResponse;
  }>()
);

export const customerAPI_GetApplicantSwiftCardsFailure = createAction(
  `${GET_APPLICANT_SWIFTCARDS_TYPE} Failure`,
  props<{
    applicantCustomerID: string;
    ticketID: number;
    error?: string | ApiError;
    retryAction?: Action;
  }>()
);

export const VERIFY_SWIFT_CARD_TYPE =
  '[DataAccessCustomerDetails] Verify Swift Card API';
export const customerAPI_verifySwiftCard = createAction(
  VERIFY_SWIFT_CARD_TYPE,
  props<{ cardNumber: string; basketItemId: number, quantityIndex: number }>()
);

export const customerAPI_verifySwiftCardSuccess = createAction(
  `${VERIFY_SWIFT_CARD_TYPE} Success`,
  props<{ verified: boolean; basketItemId: number, quantityIndex: number }>()
);

export const customerAPI_verifySwiftCardFailure = createAction(
  `${VERIFY_SWIFT_CARD_TYPE} Failure`,
  props<{
    error?: string | ApiError;
    basketItemId: number;
    quantityIndex: number;
    retryAction?: Action;
  }>()
);

export const VERIFY_MOBILE_APP_TYPE =
  '[DataAccessCustomerDetails] Verify Mobile App API';
export const customerAPI_verifyMobileApp = createAction(
  VERIFY_MOBILE_APP_TYPE,
  props<{ emailAddress: string; basketItemId: number, quantityIndex: number }>()
);

export const customerAPI_verifyMobileAppSuccess = createAction(
  `${VERIFY_MOBILE_APP_TYPE} Success`,
  props<{ verified: boolean; basketItemId: number, quantityIndex: number }>()
);

export const customerAPI_verifyMobileAppFailure = createAction(
  `${VERIFY_MOBILE_APP_TYPE} Failure`,
  props<{
    error?: string | ApiError;
    basketItemId: number;
    quantityIndex: number;
    retryAction?: Action;
  }>()
);
